import type { useCombobox } from '@mantine/core'
import type React from 'react'
import { useCallback, useEffect } from 'react'

import type { AutocompleteProps } from '../Autocomplete.types'

export const keyIsArrowDown = (key: string) => key === 'ArrowDown'
export const keyIsArrowUp = (key: string) => key === 'ArrowUp'
export const keyIsEnter = (key: string) => key === 'Enter'

export const useHandleOptionsNavigationKeydown = ({
  store,
  dropdownOpened,
  options,
  inputRef
}: {
  store: ReturnType<typeof useCombobox>
  dropdownOpened: boolean
  options: AutocompleteProps['options']
  inputRef: React.RefObject<HTMLInputElement | null>
}) => {
  const inputElement = inputRef.current
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!dropdownOpened || options.length === 0) {
        return
      }

      if (keyIsArrowDown(e.key)) {
        e.preventDefault()
        store.selectNextOption()
      }

      if (keyIsArrowUp(e.key)) {
        e.preventDefault()
        store.selectPreviousOption()
      }

      if (keyIsEnter(e.key)) {
        e.preventDefault()
        store.clickSelectedOption()
      }
    },
    [store, dropdownOpened, options.length]
  )

  useEffect(() => {
    inputElement?.addEventListener('keydown', handleKeyDown)
    return () => {
      inputElement?.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown, inputElement])
}
